'use client'
import SimpleSlider from '@/src/components/SimpleSlider/SimpleSlider'
import useAuthGuard from '@/src/hooks/useAuthGuard'
import { useGetFavouriteGamesQuery } from '@/src/services/games'
import { PositioningGroupType } from '@/src/services/types'
import { JackpotType } from '@/src/services/types/jackpot'
import { buildGameThumbnails } from '@/src/utils/helpers/thumbnails'
import { PrismicDocument } from '@prismicio/client'
import { useTranslation } from 'react-i18next'

type LobbyProps = {
  document: PrismicDocument
  groupGames: PositioningGroupType[]
  jackpots?: JackpotType[]
  children?: React.ReactNode
}

export default function LiveClient({
  groupGames,
  jackpots,
  children,
}: LobbyProps) {
  const { isLoggedIn } = useAuthGuard()
  const { t } = useTranslation(['family-groups', 'meta'])
  const { data: favouriteGames } = useGetFavouriteGamesQuery(undefined, {
    skip: !isLoggedIn,
  })

  const categories = groupGames
    .filter((groups) => groups.families.length !== 0)
    .map((group, index) => (
      <div key={group.name}>
        <SimpleSlider
          slug={group.slug}
          subPath='/live'
          title={t(group.slug, { defaultValue: group.slug })}
          items={buildGameThumbnails(
            group?.families || [],
            !!isLoggedIn,
            favouriteGames?.games || [],
            jackpots,
            group?.name,
            index < 1,
          )}
          type='games'
        />
      </div>
    ))

  return (
    <>
      <div className='mx-auto max-w-7xl'>{categories}</div>
      {!isLoggedIn && children}
    </>
  )
}
